import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMyBetsKenoGameService, placeBetKenoGameService } from '../kenoGame.service'
import { setKenoGameLosses, setKenoGameProfit, setKenoGameWagered, setKenoGameWins } from './kenoGame.slice'
import { BET_RESULT } from 'constants/index'

export const placedBetKenoGame = createAsyncThunk('keno-game/place-bet',
  async ({ payload, onSuccess }, thunkApi) => {
    try {
      const res = await placeBetKenoGameService(payload)
      onSuccess && onSuccess()
      thunkApi.dispatch(setKenoGameWagered(res?.betAmount))
      if (res?.result === BET_RESULT.WON) {
        thunkApi.dispatch(setKenoGameWins())
        thunkApi.dispatch(setKenoGameProfit(res?.winningAmount - res?.betAmount))
      } else if (res?.result === BET_RESULT.LOST) {
        thunkApi.dispatch(setKenoGameLosses())
      }
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const getMyBetsKeno = createAsyncThunk('keno-game/myBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsKenoGameService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const getMyAllBetsKeno = createAsyncThunk('keno-game/myAllBets', async (params, thunkApi) => {
  try {
    const res = await getMyBetsKenoGameService(params)
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
